/**
 * Final Unified Email Obfuscator
 * Handles:
 * 1. Custom Blocks (Involved/Footer)
 * 2. Plain emails typed into the WordPress Editor
 */
document.addEventListener("DOMContentLoaded", () => {
	// Finds every obfuscated link on the page
	const emailLinks = document.querySelectorAll(".js-obfuscated-email");

	emailLinks.forEach((link) => {
		// Get the Base64 string
		const encoded = link.getAttribute("data-email");
		if (!encoded) return;

		// Decode it
		const decoded = atob(encoded);

		// 1. Set the actual link destination
		link.href = "mailto:" + decoded;

		// 2. Handle the display text
		// If the link is a placeholder, replace it with the real email.
		// This protects the 'Footer' and 'Auto-detected' emails.
		if (
			link.textContent.trim() === "" ||
			link.textContent.includes("[email protected]")
		) {
			link.textContent = decoded;
		}
		// Note: If the text is "Contact Us", it will remain "Contact Us"!

		// Stop propagation if necessary to prevent Smooth Scroll
		// from trying to scroll to a "mailto:" link
		link.addEventListener("click", (e) => {
			e.stopPropagation();
		});

		// 3. Mobile Support
		link.addEventListener(
			"touchstart",
			() => {
				link.href = "mailto:" + decoded;
			},
			{ passive: true },
		);
	});
});
